export default __webpack_public_path__ + "static/media/trading-control.91de8d06.svg";